import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// A Note about a task or a cell, written in the app's own composer as a
// sheet over the cell (docs/tasques-pla.md, iOS). The context carries the
// link, so the Note is born attached to what it is about. Where the app does
// not declare the component the button stays an ordinary form, which opens
// the web editor — the fallback for the browser and for older builds.
export default class extends BridgeComponent {
  static component = "native-note-capture"
  static values = { context: Object }

  capture(event) {
    if (!this.enabled) return

    event.preventDefault()
    this.send("capture", this.contextValue)
  }
}
